module.exports = __webpack_public_path__ + "static/media/webdesign-services-img62.83a2dcbc.jpg";